import { Component } from 'react';

class SLUMSExamination extends Component {
  render() {
    return <h1>Saint Louis University Mental Status (SLUMS) Examination</h1>;
  }
}

export default SLUMSExamination;
